import { createContext } from 'react'

import type { TenantContextValue } from './tenant.ts'

export const TenantContext = createContext<TenantContextValue | null>(null)
